import React from "react";
import { FiMinus, FiPlus } from "react-icons/fi";

const DonationList = ({ title, rate, person, increase, decrease }) => {
  return (
    <div className="col-span-9">
      <div className="grid grid-cols-12 gap-x-4 kxl:gap-x-8 mb-2">
        <span className="col-span-6 text-custom-gray-400 text-2xl">ITEM</span>
        <span className="col-span-3 text-custom-gray-400 text-2xl">RATE</span>
        <span className="col-span-3 text-custom-gray-400 text-2xl text-center">
          PERSON
        </span>
      </div>
      <div className="mb-2 col-span-9 grid grid-cols-12 gap-x-4 kxl:gap-x-8 ">
        <div className="col-span-6 bg-white cursor-pointer px-2.5 py-3 flex items-center justify-between w-full text-2xl rounded-[5px] text-custom-gray-400">
          {title}
        </div>
        <input
          type="text"
          className="col-span-3 donation-input"
          disabled
          readOnly
          defaultValue={rate.toFixed(2)}
        />
        <div className="flex gap-x-2">
          <button onClick={decrease} disabled={person <= 0}>
            <FiMinus />
          </button>
          <div className="col-span-3 shadow-donation px-7 kxl:px-14 py-2.5 kxl:py-4 bg-white text-custom-gray-400 text-2xl kxl:text-4xl  rounded-[5px]">
            {person}
          </div>
          <button onClick={increase}>
            <FiPlus />
          </button>
        </div>
      </div>
    </div>
  );
};

export default DonationList;
